// frontend/src/routes/PrivateRoute.jsx

import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const location = useLocation();

  const {
    checked = false,
    loading = false,
    userInfo = null,
    isAuthenticated = false,
  } = useSelector((state) => state.userAuth || {});

  const userId = userInfo?.id || userInfo?._id;


  if (!checked || loading) {
    return (
      <main
        style={{ minHeight: "60vh", display: "grid", placeItems: "center" }}
      >
        <span>Checking your session…</span>
      </main>
    );
  }

  if (!isAuthenticated || !userId) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children || <Outlet />;
}
